import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormInput,
} from "shards-react";

import PageTitle from "../../components/common/PageTitle";
import firebase from "../../fire";
import { InputLabel, MenuItem, FormControl, Select } from "@material-ui/core";
import { useHistory } from "react-router";
import CancelIcon from "@material-ui/icons/Cancel";
// import MenuItem from "@material-ui/MenuItem";
// import FormControl from "@material-ui/FormControl";
// import Select from "@material-ui/Select";
export default function CreateAds() {
  const [vidtitle, setVidTitle] = useState("");
  const [file, setFile] = useState("");
  const [reward, setReward] = useState("");
  const [totalReward, settotalReward] = useState("");
  const [startDate, setStartDate] = useState("");
  const [playAt, setplayAt] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [age, setAge] = React.useState("");
  const [duration, setduration] = React.useState("");
  const [videoDuration, setvideoDuration] = React.useState(0);
  const [minutes, setminutes] = useState(0);
  const [seconds, setseconds] = useState(0);
  const [tvAds, settvAds] = React.useState("");
  const [createSwitch, setcreateSwitch] = React.useState(false);
  const history = useHistory();

  const range = (start, end, length = end - start + 1) =>
    Array.from({ length }, (_, i) => start + i);

  var Number_ = range(0, 59);

  const handleSubmit = (evt) => {
    var timePlay = Number(parseInt(minutes) * 60) + Number(parseInt(seconds));
    evt.preventDefault();
    setLoading(true);
    let adObj = null;
    const storageRef = firebase.storage().ref();
    const fileRef = storageRef.child("ads/" + file.name);
    fileRef.put(file).then(async (result) => {
      fileRef.getDownloadURL().then(function (downloadURL) {
        console.log("File available at", downloadURL);
        adObj = {
          name: vidtitle,
          file_name: downloadURL,
          duration: duration,
          playAt: timePlay,
        };
        const db = firebase.firestore();
        const userRef = db.collection("ads").add({
          name: vidtitle,
          file_name: downloadURL,
          duration: duration,
          playAt: timePlay,
        });
        setLoading(false);
        setcreateSwitch(false);
        userRef.then((res) => {
          console.log("Response on Add", res.id, age);
          updateRefAds(
            age,
            {
              ...adObj,
              id: res.id,
            },
            1
          );
        });
      });
      await Swal.fire("AD", "Tv Ad uploaded successfully", "success");
    });
  };

  const handleChangeVideoSelect = (event) => {
    setAge(event.target.value);
    console.log("Event Select", event.target.value);
    settvAds(event.target.value.ads);
    var media = new Audio(event.target.value.file_name);
    media.onloadedmetadata = function () {
      console.log("Media Time", media.duration);
      setvideoDuration(media.duration);
    };
  };

  const handleMinutes = (event) => {
    setminutes(event.target.value);
  };

  const handleSeconds = (event) => {
    setseconds(event.target.value);
  };

  const [videos, setVideos] = useState([]);
  useEffect(() => {
    setLoading(true);
    console.log("getVideo Calling");
    getVideos().then(function (result) {
      result.forEach((data) => {
        setLoading(false);
        setVideos((previous) => [...previous, data]);
      });
    });
  }, []);

  async function getVideos() {
    let arrData = [];
    const db = firebase.firestore();
    const snapshot = await db.collection("videos").get();
    snapshot.docs.forEach((item) => {
      const itemData = item.data();
      arrData.push({ ...itemData, _id: item.ref.id });
    });
    return arrData;
  }

  async function getVideosStateFresh() {
    let arrData = [];
    const db = firebase.firestore();
    const snapshot = await db.collection("videos").get();
    snapshot.docs.forEach((item) => {
      const itemData = item.data();
      arrData.push({ ...itemData, _id: item.ref.id });
    });
    setLoading(false);
    setVideos(arrData);
  }

  const removeRefer = (id) => {
    console.log("REmove", id);
    updateRefAds(age, id, 0);
    setLoading(true);
    getVideosStateFresh();
    settvAds("");
  };

  const updateRefAds = (video, data, status) => {
    console.log("updateRefAds ", video?.ads, data);
    let d = video?.ads ? video?.ads : [];
    if (status === 1) {
      d.push(data);
      settvAds([...d]);
      // setAge(video);
      console.log("updateRefAds D:", d);
    }
    if (status === 0) {
      d = d.filter((x) => x !== data);
      settvAds(d);
      console.log("status === 0 updateRefAds D:", d);
    }
    firebase
      .firestore()
      .collection("videos")
      .doc(video?._id)
      .update({
        ads: d,
      })
      .then((res) => {})
      .catch((err) => {
        console.log("Error", err);
      });
  };

  const getLeftValue = (data) => {
    console.log("Play at", data);
    var dd = (data?.playAt / videoDuration) * 100;
    console.log(`Percentage Value Left ${dd}%`);
    return `${dd}%`;
  };
  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <Row noGutters className="page-header py-4">
        <PageTitle
          sm="4"
          title="Add New TV AD"
          subtitle="TV ADs "
          className="text-sm-left"
        />
      </Row>

      <Row>
        <Col lg="9" md="12">
          <Card small className="mb-3">
            <CardBody>
              <form onSubmit={handleSubmit}>
                <div class="form-group">
                  <label for="video">AD Video</label>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={age.name}
                    label="Age"
                    onChange={handleChangeVideoSelect}
                    placeholder="Select Video to Play Ad"
                    fullWidth
                    style={{ borderBottomWidth: 0 }}
                  >
                    {Array.isArray(videos) && videos?.length > 0
                      ? videos.map((data, id) => (
                          <MenuItem value={data}>{data?.name}</MenuItem>
                        ))
                      : null}
                  </Select>
                </div>
                {/* <div className="d-flex justify-content-center">
                  {Array.isArray(age) && age?.length > 0
                    ? age.map((data, id) => (
                        <div
                          style={{
                            backgroundColor: "#3d5170",
                            minWidth: 100,
                            textAlign: "center",
                            padding: 10,
                            borderRadius: 25,
                            color: "#ffff",
                            margin: 1,
                            cursor: "pointer",
                            fontSize: 10,
                          }}
                          onClick={() => removeRefer(data?._id)}
                        >
                          {data?.name}
                        </div>
                      ))
                    : null}
                </div> */}
                {tvAds ? (
                  <div class="form-group">
                    <label for="exampleInputFullname">
                      {" "}
                      TV ADs ({tvAds?.length ? tvAds?.length : 0})
                    </label>
                    <div className="d-flex justify-content-center">
                      {Array.isArray(tvAds) && tvAds?.length > 0
                        ? tvAds.map((data, id) => (
                            <div
                              style={{
                                backgroundColor: "#3d5170",
                                minWidth: 100,
                                textAlign: "center",
                                padding: 10,
                                borderRadius: 25,
                                color: "#ffff",
                                margin: 1,
                                cursor: "pointer",
                                fontSize: 10,
                                position: "relative",
                              }}
                              onClick={() => removeRefer(data)}
                            >
                              Ad {id + 1}
                              <CancelIcon
                                fontSize={"small"}
                                style={{
                                  position: "absolute",
                                  top: "20%",
                                  right: "5%",
                                }}
                              />
                            </div>
                          ))
                        : null}
                    </div>
                  </div>
                ) : null}
                {createSwitch ? (
                  <>
                    <div class="form-group">
                      <label for="exampleInputFullname"> Ad Title </label>
                      <input
                        type="text"
                        value={vidtitle}
                        onChange={(e) => setVidTitle(e.target.value)}
                        name="startDate"
                        class="form-control"
                        id="exampleInputFullname"
                        aria-describedby="fullnameHelp"
                        placeholder="Enter Ad Title "
                      />
                    </div>
                    <div class="form-group">
                      <label for="exampleInputFullname">Duration (sec)</label>
                      <input
                        type="number"
                        value={duration}
                        onChange={(e) => setduration(e.target.value)}
                        name="startDate"
                        class="form-control"
                        id="exampleInputFullname"
                        aria-describedby="fullnameHelp"
                        placeholder="Enter Ad Duration"
                      />
                    </div>
                    <div class="form-group">
                      <label for="exampleInputFullname">
                        Play at (Video Duration is {videoDuration} sec)
                      </label>

                      <div class="row">
                        <div className="col-6">
                          <label for="exampleInputFullname">Minutes</label>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={minutes}
                            label="Age"
                            onChange={handleMinutes}
                            placeholder="Select Video to Play Ad"
                            fullWidth
                            style={{ borderBottomWidth: 0 }}
                          >
                            {Array.isArray(Number_) && Number_?.length > 0
                              ? Number_.map((data, id) => (
                                  <MenuItem value={data}>{data}</MenuItem>
                                ))
                              : null}
                          </Select>
                        </div>
                        <div className="col-6">
                          <label for="exampleInputFullname">Seconds</label>

                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={seconds}
                            label="Age"
                            onChange={handleSeconds}
                            placeholder="Select Video to Play Ad"
                            fullWidth
                            style={{ borderBottomWidth: 0 }}
                          >
                            {Array.isArray(Number_) && Number_?.length > 0
                              ? Number_.map((data, id) => (
                                  <MenuItem value={data}>{data}</MenuItem>
                                ))
                              : null}
                          </Select>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="video">Choose Ad</label>
                      <input
                        type="file"
                        // onChange={(e) => setReward(e.target.value)}
                        class="form-control"
                        accept="video/mp4,video/x-m4v,video/*"
                        id="video"
                        onChange={(e) => setFile(e.target.files[0])}
                      />
                    </div>

                    <div
                      style={{
                        height: 10,
                        width: "100%",
                        backgroundColor: "#007bff",
                        marginTop: "3%",
                        marginBottom: "3%",
                        borderRadius: 10,
                        position: "relative",
                      }}
                    >
                      {Array.isArray(tvAds) && tvAds?.length > 0
                        ? tvAds.map((data, id) => (
                            <div
                              style={{
                                height: 20,
                                width: 20,
                                backgroundColor: "#000",
                                position: "absolute",
                                borderRadius: 100,
                                left: getLeftValue(data),
                                marginTop: -5,
                              }}
                            ></div>
                          ))
                        : null}
                    </div>

                    <button
                      disabled={isLoading}
                      type="submit"
                      class="btn btn-primary"
                    >
                      {isLoading && (
                        <i className="fa fa-refresh fa-spin mr-1"></i>
                      )}
                      Upload
                    </button>
                  </>
                ) : (
                  <div className="d-flex justify-content-center mt-5">
                    <button
                      disabled={isLoading}
                      class="btn btn-primary mr-5"
                      onClick={() => history.push("/videos")}
                    >
                      Back to Video
                    </button>
                    <button
                      disabled={isLoading}
                      class="btn btn-primary ml-5"
                      onClick={async () => {
                        // if (tvAds) {
                        setcreateSwitch(!createSwitch);
                        // } else {
                        //   await Swal.fire(
                        //     "Error",
                        //     "Kindly Select Video!",
                        //     "error"
                        //   );
                        // }
                      }}
                    >
                      {isLoading && (
                        <i className="fa fa-refresh fa-spin mr-1"></i>
                      )}
                      Add TV Ads
                    </button>
                  </div>
                )}
              </form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
